export const TYPE = {
  SET: 'set',
  PROJECT: 'project',
  ITEM: 'item',
  COLOR: 'color',
};

export const FILTER_KEYS = {
  PAGE: 'page',
  PER_PAGE: 'limit',
  HAS_MORE: 'hasMore',
  SORT_DIRECTION: 'orderBy',
  CATEGORIES: 'category',
  MANUFACTURERS: 'manufacturer',
  TYPE: 'type',
  STORAGE: 'storage',
  QUANTITY: 'count',
  ITEMS: 'items',
  TAGS: 'tags',
  // SORT_BY: 'orderBy',

};

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const SEARCH_QUERY_KEYS = {
  ITEMS: 'items',
  TAGS: 'tags',
  COLORS: 'colors',
};
